import React from 'react'

function Cities() {
  return (
    <ol className="list-group" style={{ margin: "1em" }}>
      <li className="list-group-item">
        <h5>Şehirler</h5>
      </li>
      <button href="#" className="list-group-item list-group-item-action ">
        İstanbul
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        Ankara
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        İzmir
      </button>
      <button href="#" className="list-group-item list-group-item-action ">
        Eskişehir
      </button>
    </ol>
  );
}

export default Cities